import React, { useState } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import "./SummaryCountCard.scss"
import HrbTranslate from '../../../components/language/HrbTranslate';
import EmdashText from '../../../components/library/common/EmdashText';
import { QueueTableTypes } from '../enums/QueueTableTypes';
import { SummaryIcons } from '../icons/SummaryIcons';

const SummaryCountCard = props => {
    const { loading, isEmpty, textKey, count, children, onClick, tableType, isNewMessages, filterClickedState } = props;
    const handleClick = () => {
        onClick();
    }

    return (
        <div className={classnames('summary-count-card', {
            'unassigned': tableType === QueueTableTypes.UNASSIGNED,
            'new-messages': isNewMessages && count !== 0,
            'clicked': filterClickedState
        })} onClick={handleClick}>
            {
                filterClickedState &&
                <div className='summary-icon-click' >
                    {SummaryIcons.ICON_CLICK}
                </div>
            }

            <div className='scc'>
                <div className={classnames('scc-icon', { 'clicked': filterClickedState })}>
                    {children}
                </div>
                <div className='scc-header has-text-centered'>
                    <HrbTranslate className='p1' text={textKey} />
                </div>
            </div>
            <div className={classnames('scc-footer has-text-centered', { 'clicked': filterClickedState })}>
                {(loading || isEmpty) &&
                    <h4><EmdashText /></h4>
                }
                {!loading && !isEmpty &&
                    <h4>{count}</h4>
                }
            </div>
        </div>
    )
}


SummaryCountCard.propTypes = {
    textKey: PropTypes.string.isRequired,
    loading: PropTypes.bool,
    isEmpty: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]),
    tableType: PropTypes.string,
    isNewMessages: PropTypes.bool
}

export default SummaryCountCard